import { css, styled } from 'styled-components';
import { computeRemSize } from '@ydistri/theme';

/**
 * The `MCP: {name}` badge every MCP in the dock header wears. The base is a plain, non-interactive
 * span - a badge that only reports a state must not be clickable by accident; the one MCP with a
 * login (ydistri-devs) wraps the same look in a button.
 */
const mcpBadgeStyle = css<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  flex: 0 0 auto;
  padding: 0.125rem 0.5rem;
  border: 1px solid ${p => p.$color};
  border-radius: 999px;
  background: transparent;
  color: ${p => p.$color};
  font-size: ${computeRemSize(11)};
  white-space: nowrap;
`;

export const McpBadge = styled.span<{ $color: string }>`
  ${mcpBadgeStyle}
`;

export const McpBadgeButton = styled.button<{ $color: string }>`
  ${mcpBadgeStyle}
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.8;
  }
`;

export const McpBadgeDot = styled.span<{ $color: string }>`
  flex: 0 0 auto;
  width: ${computeRemSize(6)};
  height: ${computeRemSize(6)};
  border-radius: 50%;
  background: ${p => p.$color};
`;
